import { Component, ViewContainerRef } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { BlockUiService } from '../../services/blockui.service';
import { CaseService } from '../../services/case.service';

@Component({
	selector: 'app-lawyer-workload-admin',
	templateUrl: './lawyer-workload-admin.component.html'
})
export class LawyerWorkloadAdminComponent {

	dateFrom: Date = null;
	error = '';

	constructor(
		private reportService: ReportService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private caseService: CaseService
	) { }

	exportWorkload() {
		this.error = '';
		if (!this.dateFrom) {
			this.error = 'Моля, изберете начална дата.';
			return;
		}

		const from = this.caseService.toBackendIsoDate(this.dateFrom);
		if (!from) {
			this.error = 'Невалидна дата.';
			return;
		}

		this.blockUi.start(this.vcRef);
		this.reportService.executeLawyerWorkloadReport(from).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = 'natovarenost_advokati_' + from + '.xlsx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				this.error = 'Грешка при генериране на справката.';
			}
		);
	}
}
